import { useState } from "react";

const { MenuItem } = require("@mui/material");
const {
  default: CustomFormControl,
} = require("features/bidding-center/Dropdown/CustomFormControl");

const KeywordsMatchTypeDropdown = ({title, value, options = [], onChange }) => {
  const [selectedValue, setSelectedValue] = useState(value || "");
  return (
    <CustomFormControl
      minWidth={"125px"}
      displayEmpty
      renderValue={(selected) => {
        if (!selected) {
          return (
            <span
              style={{
                fontSize: "12px",
                color: "#bab7b7",
              }}
            >
              {title}
            </span>
          );
        }
        const opt = options.find((o) => o.value === selected);
        return opt?.label ?? selected;
      }}
      onChange={async (e) => {
        await onChange(e.target.value);
        setSelectedValue(e.target.value || "");
      }}
      value={selectedValue}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: "5px",
            border: "1px solid #C4C4C4",
            boxShadow: "none",
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem className="dropdown-item" key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </CustomFormControl>
  );
};

export default KeywordsMatchTypeDropdown;
